import styled from 'styled-components';

export const Node = styled.div`
  display: flex;
  padding: 0 16px 16px 0;
`;

export const Overlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.lpbDashboard.colors.tileOverlayBg};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  opacity: 0;
  visibility: hidden;
`;

export const Arrow = styled.div`
  width: 64px;
  height: 64px;
  background: ${({ theme }) => theme.lpbDashboard.colors.tileArrowsBg};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    fill: ${({ theme }) => theme.lpbDashboard.colors.tileOverlayLink};
  }
`;

export const Link = styled.a`
  cursor: pointer;
  /* font-family: var(--commonSans); */
  display: block;
  width: 256px;
  background-color: ${({ theme }) => theme.lpbDashboard.colors.tileLinkBg};
  border-radius: 3px;
  box-shadow: ${({ theme }) => theme.lpbDashboard.tile.boxShadow};
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: ${({ theme }) => theme.lpbDashboard.tile.boxShadowHover};

    ${Overlay} {
      opacity: 1;
      visibility: visible;
    }
  }
`;

export const ImgBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 193px;
  border-bottom: 1px solid ${({ theme }) => theme.lpbDashboard.colors.tileImgBoxBorder};
  background-color: ${({ theme }) => theme.lpbDashboard.colors.tileImgBoxBg};
  position: relative;

  & img {
    display: block;
    width: 100%;
    height: 100%;
    max-width: 100%;
  }
`;

export const Info = styled.div`
  padding: 18px 24px;
`;

export const Title = styled.h2`
  font-size: 16px;
  line-height: 22px;
  margin-top: 6px;
  margin-bottom: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.lpbDashboard.colors.tileTitleColor};
`;

export const Description = styled.p`
  font-size: 13px;
  font-weight: 300;
  line-height: 20px;
  color: ${({ theme }) => theme.lpbDashboard.colors.tileDescriptionColor};
`;

export const Abbr = styled.span`
  font-size: 67px;
  font-weight: 500;
  color: ${({ theme }) => theme.lpbDashboard.colors.tileAbbrText};
`;
